import React from "react";
import { Autocomplete } from "@mui/material";
import { TextField, TextFieldProps } from "@mui/material";

const SearchInput = ({
  params,
  label,
  handleChangeInput,
}: {
  params: TextFieldProps;
  label: string;
  handleChangeInput: (e: React.ChangeEvent<HTMLInputElement>) => void;
}) => <TextField autoFocus label={label} onChange={handleChangeInput} {...params} />;

interface IProps<Option> {
  label: string;
  onChange: (value: Option) => void;
  options: Option[];
  getOptionLabel: (option: Option) => string;
  getOptionSelected: (option: Option, value: Option) => boolean;
  handleChangeInput: (e: React.ChangeEvent<HTMLInputElement>) => void;
  loading: boolean;
  open: boolean;
  setOpen: (isOpen: boolean) => void;
  style?: React.CSSProperties;
}
const SearchAutocomplete = <Option,>({
  label,
  onChange,
  options,
  getOptionLabel,
  getOptionSelected,
  handleChangeInput,
  loading,
  open,
  setOpen,
  style,
}: IProps<Option>): React.ReactElement => (
  <Autocomplete
    size="small"
    style={{ width: 200, ...style }}
    open={open}
    onOpen={() => setOpen(true)}
    onClose={() => setOpen(false)}
    isOptionEqualToValue={getOptionSelected}
    getOptionLabel={getOptionLabel}
    onChange={(_, newValue) => {
      //@ts-ignore
      newValue ? onChange(newValue) : onChange({});
    }}
    options={options}
    loading={loading}
    renderInput={(params) => (
      <SearchInput params={params} label={label} handleChangeInput={handleChangeInput} />
    )}
  />
);

export default SearchAutocomplete;
